import React from "react"
import PropTypes from 'prop-types'

import SelectGenericNew from "../../../../../gd-ui/select-generic-new/select-generic-new"
import FieldRag_DropdownOption from "../../components/dropdown/option";
import FieldRag_DropdownValueNotEmpty from "../../components/dropdown/value-not-empty";
import {FieldAutomationActionFormProps} from "../../../../render/automation-action-form";

const debug = false
// const debug = "RagActionForm"

export default class FieldRag_AutomationActionForm extends React.Component<FieldAutomationActionFormProps,any> {

    static propTypes = {
        field           : PropTypes.object,
        config          : PropTypes.object,

        options         : PropTypes.array,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationActionFormProps) {
        super(props)

        this.state = {
            toValue         : _.get(props.config, 'toValue', null)
        }
    }

    onChangeToValue = (option:any) => {
        const toValue = option.value

        this.setState({
            toValue
        }, ()=>{
            this.props.onChangeCallback({toValue})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        return (
            <div className="flex-row-left-top">
                <div className="label w-100">to</div>
                <SelectGenericNew className                     = "selector w-180"
                                  options                       = {this.props.field.getAutomationOptions()}
                                  value                         = {this.state.toValue}
                                  popoverScrollContainerClasses = "max-h-200 max-w-300"
                                  valueComponent                = {FieldRag_DropdownValueNotEmpty}
                                  popoverOptionComponent        = {FieldRag_DropdownOption}
                                  isSearchable                  = {true}
                                  disabled                      = {this.props.config.disabled}
                                  onChange                      = {this.onChangeToValue}/>
            </div>
        )
    }
}
